
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, InputAdornment } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/GetApp';
import SearchIcon from '@mui/icons-material/Search';
import { GridOn } from '@mui/icons-material';
import { exportGenericWorkbook } from '../utils/excel/genericWorkbook';

const initialForm = { descripcion: '', tipo: 'contado', dias_credito: '' };


export default function CondicionPago() {
    // Paginación estilo Categorías
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);

    const handleChangeRowsPerPage = e => {
      setRowsPerPage(Number(e.target.value));
      setPage(0);
    };
  const [condiciones, setCondiciones] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState('');
  const tableRef = useRef();

  const fetchCondiciones = async () => {
    const res = await axios.get('/api/condicion-pago');
    setCondiciones(Array.isArray(res.data) ? res.data : []);
  };

  useEffect(() => { fetchCondiciones(); }, []);

  const handleOpen = (cond = null) => {
    setEditing(cond);
    setForm(cond ? { ...cond } : initialForm);
    setOpen(true);
  };
  const handleClose = () => { setOpen(false); setEditing(null); };
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };
  const handleSave = async () => {
    try {
      if (editing) await axios.put(`/api/condicion-pago/${editing.id}`, form);
      else await axios.post('/api/condicion-pago', form);
      fetchCondiciones(); setOpen(false);
    } catch (err) { alert(err.response?.data?.error || 'Error al guardar'); }
  };
  const handleDelete = async id => { try { await axios.delete(`/api/condicion-pago/${id}`); fetchCondiciones(); } catch { alert('Error al eliminar'); } };

  const exportExcel = async () => {
    await exportGenericWorkbook({
      titulo: 'REPORTE DE CONDICIONES DE PAGO',
      sheetName: 'CondicionesPago',
      tableName: 'tblCondicionesPago',
      fileName: 'CondicionesPago',
      columns: [
        { key: 'id', label: 'ID', width: 8 },
        { key: 'descripcion', label: 'Descripción', width: 30 },
        { key: 'tipo', label: 'Tipo', width: 16 },
        { key: 'dias_credito', label: 'Días Crédito', width: 14 }
      ],
      rows: filtered,
      searchText: search,
      usuario: ''
    });
  };

  const filtered = condiciones.filter(c =>
    (c.descripcion || '').toLowerCase().includes(search.toLowerCase()) ||
    (c.tipo || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800 }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Condiciones de Pago</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar..."
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(0); }}
            size="small"
            InputProps={{ startAdornment: <Box sx={{ color: 'text.secondary', mr: 1 }}><SearchIcon /></Box> }}
            sx={{ flex: 1 }}
          />
          <Button variant="contained" color="success" startIcon={<GridOn />} onClick={exportExcel} sx={{ minWidth: 120 }}>
            Exportar Excel
          </Button>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
            Nueva Condición
          </Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            sx={{ width: 100 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }} ref={tableRef}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Descripción</TableCell>
                <TableCell align="center">Tipo</TableCell>
                <TableCell align="center">Días Crédito</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.length > 0 ? (
                filtered.slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage).map(c => (
                  <TableRow key={c.id}>
                    <TableCell align="center">{c.descripcion}</TableCell>
                    <TableCell align="center">{c.tipo}</TableCell>
                    <TableCell align="center">{c.dias_credito || '-'}</TableCell>
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                        <IconButton color="primary" onClick={() => handleOpen(c)} size="small" title="Editar"><EditIcon /></IconButton>
                        <IconButton color="error" onClick={() => handleDelete(c.id)} size="small" title="Eliminar"><DeleteIcon /></IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">Sin registros</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Paginación fuera del recuadro, alineada a la derecha */}
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 1, userSelect: 'none', fontSize: '0.9375rem', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontWeight: 500 }}>
          <span
            style={{
              color: page === 0 ? '#aaa' : '#1976d2',
              cursor: page === 0 ? 'default' : 'pointer',
              marginRight: 16,
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
              fontWeight: 500
            }}
            onClick={() => page > 0 && setPage(page - 1)}
          >ANTERIOR</span>
          <span
            style={{
              color: (rowsPerPage === -1 ? true : (page + 1) * rowsPerPage >= filtered.length) ? '#aaa' : '#1976d2',
              cursor: (rowsPerPage === -1 ? true : (page + 1) * rowsPerPage >= filtered.length) ? 'default' : 'pointer',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
              fontWeight: 500
            }}
            onClick={() => (rowsPerPage === -1 ? false : (page + 1) * rowsPerPage < filtered.length) && setPage(page + 1)}
          >SIGUIENTE</span>
        </Box>
        <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="xs" fullWidth>
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              {editing ? 'Editar' : 'Nueva'} Condición de Pago
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2, mb: 2 }}>
              <TextField label="Descripción" name="descripcion" value={form.descripcion} onChange={handleChange} fullWidth required />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
              <TextField select label="Tipo" name="tipo" value={form.tipo} onChange={handleChange} fullWidth required SelectProps={{ native: true }}>
                <option value="contado">Contado</option>
                <option value="credito">Crédito</option>
              </TextField>
              {form.tipo === 'credito' && (
                <TextField label="Días Crédito" name="dias_credito" value={form.dias_credito} onChange={handleChange} type="number" fullWidth required />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="error" variant="contained" startIcon={<CloseIcon />}>
              Cancelar
            </Button>
            <Button onClick={handleSave} variant="contained" color="primary" startIcon={<SaveIcon />}>
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
